const ecpRoutes = [
  {
    path: "/diag",
    name: "",
    meta: {
      title: "역량진단",
      isDynamic: true,
    },
    children: [
      /** 핵심역량진단 */
      {
        path: "core", // /diag/core
        name: "diagCore",
        meta: {
          title: "핵심역량진단",
          isDynamic: true,
        },
        children: [
          {
            path: "", // /diag/core
            name: "diagCoreIndex",
            meta: {
              title: "핵심역량진단",
              menuCd: "STUDENT_DIAG_CORE",
              isDynamic: true,
            },
            component: () => import("@/views/student/diag/core/DiagCoreIndex.vue"),
          },
          {
            path: "take", // /diag/core/take
            name: "diagCoreTake",
            meta: {
              title: "진단응시",
              menuCd: "STUDENT_DIAG_CORE",
              isDynamic: true,
            },
            component: () => import("@/views/student/diag/cmmn/DiagAbilityTake.vue"),
          },
        ],
      },
      /** 전공능력진단 */
      {
        path: "major", // /diag/major
        name: "diagMajor",
        meta: {
          title: "전공능력진단",
          isDynamic: true,
        },
        children: [
          {
            path: "", // /diag/major
            name: "diagMajorIndex",
            meta: {
              title: "전공능력진단",
              menuCd: "STUDENT_DIAG_MAJOR",
              isDynamic: true,
            },
            component: () => import("@/views/student/diag/major/DiagMajorIndex.vue"),
          },
          {
            path: "take", // /diag/major/take
            name: "diagMajorTake",
            meta: {
              title: "진단응시",
              menuCd: "STUDENT_DIAG_MAJOR",
              isDynamic: true,
            },
            component: () => import("@/views/student/diag/cmmn/DiagAbilityTake.vue"),
          },
        ],
      },
      /** 설문조사 */
      {
        path: "survey", // /diag/survey
        name: "diagSurveyIndex",
        meta: {
          title: "설문조사",
          menuCd: "STUDENT_DIAG_SURVEY",
          isDynamic: true,
        },
        component: () => import("@/views/student/diag/survey/DiagSurveyIndex.vue"),
      },
      {
        path: "survey/:planId", // /diag/survey/:planId
        name: "diagSurveyPlan",
        meta: {
          title: "설문조사",
          menuCd: "STUDENT_DIAG_SURVEY",
          isDynamic: true,
        },
        component: () => import("@/views/student/diag/survey/DiagSurveyIndex.vue"),
      },
      {
        path: "worknet", // /diag/worknet
        name: "diagWorknetIndex",
        meta: {
          title: "워크넷 진단",
          menuCd: "STUDENT_WORKNET",
          isDynamic: true,
        },
        component: () => import("@/views/student/diag/worknet/DiagWorknetIndex.vue"),
      },
      {
        path: "guidance", // /diag/guidance
        name: "diagGuidanceIndex",
        meta: {
          title: "한국가이던스 진단",
          menuCd: "STUDENT_GUIDANCE",
          isDynamic: true,
        },
        component: () => import("@/views/student/diag/guidance/DiagGuidanceIndex.vue"),
      },
    ],
  },
];
export default ecpRoutes;
